import { render } from "./pop-up.vue?vue&type=template&id=a7d4a040&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"

import "./pop-up.vue?vue&type=style&index=0&id=a7d4a040&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a7d4a040"

export default script